import { Tooltip } from "@mui/material";
import { IHeaderParams } from "ag-grid-community";
import { IHeaderReactComp } from "ag-grid-react";
import { classHOC } from "components/app/ClassWrapper";
import {
  CSSProperties,
  forwardRef,
  MouseEvent,
  TouchEvent,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const GridHeader = forwardRef<
  IHeaderReactComp & { refresh: () => boolean },
  IHeaderParams & { headerTooltip?: string; tooltipStyle: CSSProperties }
>(
  (
    { enableMenu, enableSorting, showColumnMenu, column, setSort, displayName, headerTooltip = "" },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      refresh: () => false,
    }));

    const getCurrentSortOrder = () =>
      column.isSortAscending() ? "asc" : column.isSortDescending() ? "desc" : "none";

    const getNextSortOrder = () =>
      column.isSortAscending() ? "none" : column.isSortDescending() ? "asc" : "desc";

    const [sortState, setSortState] = useState<"asc" | "desc" | "none">(getCurrentSortOrder());
    const refButton = useRef<HTMLDivElement>(null);

    const [showMenu, setShowMenu] = useState(false);

    const onMenuClicked = () => {
      refButton.current ? showColumnMenu(refButton.current) : null;
    };

    const onSortChanged = () => {
      setSortState(getCurrentSortOrder());
    };

    const onSortRequested = (
      order: string,
      event: MouseEvent<HTMLDivElement> | TouchEvent<HTMLDivElement>
    ) => {
      setSort(order, event.shiftKey);
    };

    useEffect(() => {
      column.addEventListener("sortChanged", onSortChanged);
      onSortChanged();
    }, []);

    return (
      <Tooltip
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: headerTooltip,
            }}
          />
        }
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            // marginTop: 10,
            cursor: enableSorting ? "pointer" : "default",
          }}
          onMouseEnter={() => setShowMenu(true)}
          onMouseLeave={() => setShowMenu(false)}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              overflow: "hidden",
            }}
            onClick={(event) =>
              enableSorting ? onSortRequested(getNextSortOrder(), event) : undefined
            }
            onTouchEnd={(event) =>
              enableSorting ? onSortRequested(getNextSortOrder(), event) : undefined
            }
          >
            <span className="ag-header-cell-text">{displayName}</span>
          </div>
          {enableSorting ? (
            <div
              style={{ display: "inline-block" }}
              onClick={(event) => onSortRequested(getNextSortOrder(), event)}
              onTouchEnd={(event) => onSortRequested(getNextSortOrder(), event)}
            >
              <div>
                <span className={`ag-icon ag-icon-${sortState}`}></span>
              </div>
            </div>
          ) : null}
          {enableMenu ? (
            <div
              ref={refButton}
              onClick={() => onMenuClicked()}
              style={{
                opacity: showMenu ? 1 : 0,
                transition: "opacity 0.2s ease 0s, border 0.2s ease 0s",
              }}
            >
              <span className={`ag-icon ag-icon-menu`}></span>
            </div>
          ) : null}
        </div>
      </Tooltip>
    );
  }
);

export default classHOC(GridHeader);
